<template>
    <div id="body">
        <b-container>
            <div class="box-paper">
                <img src="@/assets/ver2/paper_writing.png" alt="">
                <div class="box-time">
                    <span>00</span>:<span>00</span>
                </div>
                <div class="box-text">
                    <textarea name="" id="" cols="90" rows="11"></textarea>
                </div>
            </div>
            <div class="box-button">
                <img class="button-next" @click="$bvModal.show('bv-modal-next')" src="@/assets/ver2/button_next.png" alt="">
                <!-- <img class="button-nhap" src="@/assets/ver2/button_nhap.png" alt=""> -->
                <!-- <img class="button-support" src="@/assets/ver2/support_tutorial.png" alt=""> -->
            </div>
            
        </b-container>
        <b-modal id="bv-modal-next" class="custom_modal" centered size="lg" hide-footer hide-header>
            <div class="box-modal-next">
                <img class="modal-next" src="@/assets/ver2/modal_submit.png">
                <div class="modal-box-button submit">
                    <b-button class="mb-3 modal-button_cancel" @click="$bvModal.hide('bv-modal-next')" block >Không</b-button>
                    <b-button class="mb-3 modal-button_next" @click="$bvModal.hide('bv-modal-next')" block >Có</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    
    components: {
        
    },
    computed: {
       
    },
    data () {
        return {
        }
    },
    watch: {
    },
    methods: {
       
    },
    created() {
    }
}
</script>
<style lang="scss" scoped>
</style>